import React, {useState} from 'react'
import {Block, Row} from 'jsxstyle'

interface IconTextButtonProps {
  text: string
  icon: React.ReactElement
  color?: string
  onClick: () => void
}

const IconTextButton: React.FC<IconTextButtonProps> = ({text, icon, color = '#000000', onClick}) => {
  const [isHovered, setIsHovered] = useState(false)

  const styledIcon = React.cloneElement(icon, {
    color: color,
    width: 18,
    height: 18,
  })

  const bgColorHover = `${color}15`

  return (
    <Row
      width="fit-content"
      cursor="pointer"
      props={{
        onClick: (e) => {
          e.stopPropagation()
          onClick()
        },
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
      }}
      gap="8px"
      alignItems="center"
      padding="8px 12px"
      borderRadius="24px"
      backgroundColor={isHovered ? bgColorHover : 'transparent'}
      border={isHovered ? `1px solid ${color}` : '1px solid transparent'}
      transition="all 0.2s ease-in-out"
    >
      {styledIcon}
      <Block color={color} fontWeight={500} fontSize="12px">
        {text}
      </Block>
    </Row>
  )
}

export default IconTextButton
